import React, { useState } from 'react'
import Classes from './Faq.module.css'
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import SparklesIcon from '../../../../../utils/Icons';

export default function Faq() {
    const navigateTo = useNavigate();
    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: "Who is LightTrack designed for?",
            answer: "LightTrack is built for architects, interior designers, lighting consultants, and 3D artists who work with lighting specifications every day. It’s perfect for anyone who wants to find, compare, and organize lighting products faster and more accurately."
        },
        {
            question: "Can I export fixture data for my projects?",
            answer: "Yes — LightTrack lets you easily export fixture data in multiple formats for seamless use in your design files, project reports, or presentations. It’s built to save time and ensure your specs stay organized across every stage of your workflow."
        },
        {
            question: "How do I submit my lighting products to LightTrack?",
            answer: "Manufacturers can submit their products directly through our online portal. Once approved, they’ll be featured in our searchable database so designers and architects can discover, compare, and specify them for upcoming projects."
        },
        {
            question: "What’s included in the Premium plan?",
            answer: "The Premium plan gives you access to advanced project tools, unlimited exports, product analytics, and early access to new releases. It’s designed for professionals managing multiple projects who need faster workflows and deeper insights."
        },
        {
            question: "Is LightTrack available internationally?",
            answer: "Yes — LightTrack is available worldwide and supports users in multiple regions. Our platform automatically adjusts units, currencies, and data formats to make it easy for global teams to collaborate on lighting specifications."
        },
    ];

    return (
        <>
            <section id='faq' className={`${Classes.section} layoutPadding`}>
                <div className={Classes.faqsLeft} >
                    {/* Badge */}
                    <div className='badge'>
                        <SparklesIcon size={17} color='var(--secondary-color)' />
                        FAQS
                    </div>

                    {/* Heading + sub */}
                    <h2 className='homeTitle'> Frequently Asked <br /> Questions </h2>
                    <p className={`homeSubTitle ${Classes.faqSubtext}`} >
                        Find answers to common questions about our membership plans <br /> and scheduling your fuel delivery. Need more help?
                        <span onClick={() => { navigateTo('/contact-us') }} style={{ color: 'var(--primary-color)', fontWeight: '600', cursor: 'pointer' }} > Contact us</span>.
                    </p>
                </div>

                <div id='questions' className={Classes.faqs}>
                    <div className={Classes.faqsCon}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                sx={{
                                    border: '1px solid #80808024',
                                    boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                                    marginBottom: '1rem',
                                    borderRadius: '7px !important',
                                    padding: '6px 20px !important',
                                    '&:before': {
                                        display: 'none',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index + 1}bh-content`}
                                    id={`panel${index + 1}bh-header`}
                                    sx={{
                                        minHeight: '32px !important',
                                        margin: '0 !important',
                                        padding: '0px 10px !important',
                                        '&.Mui-expanded': {
                                            margin: '0 !important',
                                            minHeight: '32px !important',
                                            padding: '0px 10px !important',
                                        },
                                        '.MuiAccordionSummary-content': {
                                            margin: '10px 0 !important'
                                        },
                                        '.MuiAccordionDetails-root': {
                                            padding: '8px 12px 16px !important'
                                        },
                                    }}
                                >
                                    <div className={Classes.AccordionHeader}>
                                        <h5>{faq.question}</h5>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className={Classes.accordinBody}
                                    sx={{
                                        padding: '8px 16px 16px 10px !important',
                                    }}
                                >
                                    <h5 className={Classes.accordionText}>{faq.answer}</h5>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}
